import { Route, Switch } from 'react-router-dom';
import RouteChecker from './RouteChecker';
import SetupGuideContainer from '../containers/SetupGuideContainer';
import { BASE_ROUTE } from '../constants/routeConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Routes() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Switch, {
      children: /*#__PURE__*/_jsx(Route, {
        path: BASE_ROUTE,
        children: /*#__PURE__*/_jsx(SetupGuideContainer, {})
      })
    }), /*#__PURE__*/_jsx(RouteChecker, {})]
  });
}